import React from 'react';
import styles from './CandidateFooter.module.scss';

export const CandidateFooter = () => (
  <div className={styles.root}>
    Need Help? Contact us at <a href="mailto:team@checkmate.tech">team@checkmate.tech</a>
  </div>
);
